// removed by extract-text-webpack-plugin
module.exports = {"panel":"r9ttxfcvry7q6hky513sjqr6k2z4yb4n8gkzmxm13rq45zbdes598jzqnu1sksj435hdbrn6fn9e5t71hpgeqgay735pyc2shsrag9-styles-module-panel","panelTitle":"_3sw8h672xfhm2skeqxqkcqmtfg383maaawmbd5u51ntvmvzdyp5nr12t59dy7as8zwrp42zysmh6zbq4w2tph84z73ztrchwz7xvkhg-styles-module-panelTitle","panelDetails":"_31xkphp6aandbt6n7qmc3wpdxcu9735k6cg1s2yrvkv5vcs4k3g2axpspx1zep5emf23jp2xnb496fa8zrj77dz7fs4tgqqmt9qd3va-styles-module-panelDetails"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/Expansion/styles.module.sass
// module id = 379
// module chunks = 0